import { FC } from "react";
import { Select } from "antd";
import { NegotiationStatus } from "../../../../types/ProjectTypes";
import { negotiationStatusToString } from "../ProjectStatusCell";

interface NegotiationStatusSelectProps {
    /** The status set on this output, if ops picked one. */
    value?: NegotiationStatus;
    /** The deal's status today; shown until ops pick another. */
    current?: NegotiationStatus;
    onChange: (status: NegotiationStatus) => void;
}

/**
 * Picks the deal's negotiation status for publish. Any value can be set; the
 * field starts on the deal's current status (not started for a new deal) and
 * only writes to the output once ops change it.
 */
export const NegotiationStatusSelect: FC<NegotiationStatusSelectProps> = ({
    value,
    current,
    onChange,
}) => (
    <Select
        style={{ width: "100%" }}
        value={value ?? current ?? NegotiationStatus.NOT_STARTED}
        onChange={onChange}
        options={Object.values(NegotiationStatus).map((status) => ({
            value: status,
            label: negotiationStatusToString(status),
        }))}
    />
);
